module.exports = __webpack_public_path__ + "img/lg_ring_y_e_null_0@3x.a9af50ab.png";